import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-assumptions.md.
export const Route = createFileRoute('/_app/assumptions')({
  component: AssumptionsPage,
});

function AssumptionsPage() {
  return <ComingSoon slug="assumptions" />;
}
